// ----------------------------------------------------------------------------
// Template: Pages
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

//Scripts
import 'sections/header/header';
import 'sections/hero-banner/hero-banner';
import 'sections/intro-block/intro-block';
import 'sections/content-panel/content-panel';
import 'sections/numbered-cards/numbered-cards';
import 'sections/helper-cards/helper-cards';
import 'sections/banner/banner-block';
import 'sections/faqs/faqs';
import 'sections/tabs/tabs';
import 'sections/collection-list/collection-list';
import 'sections/image-video/image-video';
import 'sections/announcement-bar/announcement-bar--dismissible';
import 'sections/sticky-bar/sticky-bar';
import 'sections/content-cards/content-cards';
import 'sections/promo-cards/promo-cards';
import 'sections/series-cards/series-cards';
import 'sections/damper-slider/damper-slider';
import 'sections/featured-collection/featured-collection';
import 'sections/blog-posts/blog-posts';
import 'sections/newsletter/newsletter';
import 'sections/page-header/page-header';
import 'sections/rich-text/rich-text';
import 'sections/video-banner/video-block';
import 'sections/footer/footer';
import 'sections/country-modal/country-modal';
import 'sections/image-panel/image-panel';
import 'sections/shop-categories/shop-categories';
import 'sections/fork-carousel/fork-carousel';
import 'sections/blog-hero-carousel/blog-hero-carousel';
import 'sections/series-shop-element/series-shop-element';
import 'sections/blog-article-quote/blog-article-quote';
import 'sections/blog-article-text/blog-article-text';
import 'sections/blog-article-media/blog-article-media';
import 'sections/blog-article-featured-products/blog-article-featured-products';

// Styles
import './_pages.scss';